import { Grid, Typography as Type } from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";

const CategoryDetails = () => {
  const location = useLocation();
  const { prodCategoryId } = location?.state || {};
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/productCategory", text: "Product Category" },
      {
        key: "3",
        href: `/productCategory`,
        text: `View Details`,
      },
    ]);
  }, [prodCategoryId]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "20% 85%",
        height: "100vh",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <LeftSideNav />

      <div
        style={{
          display: "grid",
          gridTemplateRows: "15% 80%",
          backgroundColor: Colors.bgColor,
        }}
      >
        <div style={{ width: "94%" }}>
          <TopNavBar leftSideText={'Product Category Detail'} />
          <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
        </div>

        <TableContainer
          component={Paper}
          style={{
            width: "90%",
            border: "1px solid #ccc",
            borderRadius: "15px",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            marginTop: "10px",
            paddingLeft: "20px",
            paddingRight: "20px",
            marginLeft: "25px",
          }}
        >
          <h1 style={mainHeadingStyle}>Product Category Information</h1>

          <hr />
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid
              item
              xs={12}
              sm={4}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 0",
                width: "30vw",
                marginLeft: "20px",
              }}
            >
              <Type variant="subtitle1" style={labelInfoStyle}>
                <span style={labelTxtStyle}>Product Metal Name</span>
              </Type>
              <Type
                style={{
                  width: "100%",
                  justifyContent: "start",
                  display: "flex",
                }}
              >
                <div style={inputTextStyle}>
                  :
                  <p
                    style={{
                      fontSize: 16,
                      fontWeight: "400",
                      fontFamily: Fonts.Poppins,
                      color: Colors.darkGray,
                      marginLeft: "5px",
                    }}
                  >
                    {prodCategoryId?.product_metal_name || '-'}
                  </p>
                </div>
              </Type>
            </Grid>
          </Grid>
        </TableContainer>
      </div>
    </div>
  );
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "500",
  fontFamily: Fonts.Poppins, // Ensure this matches the loaded font
  color: Colors.headingBlackColor,
  display: "flex",
  marginTop: "20px",
  marginBottom: "20px",
};

const labelInfoStyle = {
  display: "flex",
  alignItems: "center",
  width: "80%",
};

const labelTxtStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

export default CategoryDetails;
